import { getFirstDayOfCurrentMonth } from './helpers.ts';

export const DEFAULT_PAYOUT_DATE = getFirstDayOfCurrentMonth();
